import { Controller } from 'stimulus'

// The client decides who may carry the deal; with no client yet, the responsable's own books.
export default class extends Controller {
  static targets = ['owner', 'portfolio', 'wrapper']

  connect() {
    this._owners = null
    this._books = null
    this._preselect = this.data.get('portfolio')
    if (this.hasOwnerTarget && this.ownerTarget.value) this.loadPortfolios()
  }

  // crm-client-search:picked — the client changed (detail.clientId may be empty).
  loadForClient(event) {
    const clientId = event.detail && event.detail.clientId
    if (!clientId) {
      this._owners = null
      this._books = null
      this.loadPortfolios()
      return
    }

    this._fetch(this.data.get('client-owners-url'), { client_id: clientId }).then((data) => {
      this._owners = data.owners || []
      this._books = data.portfolios || []
      this._fillOwners()
      this._fillPortfolios(this._booksForOwner())
    })
  }

  loadPortfolios() {
    if (this._books) { this._fillPortfolios(this._booksForOwner()); return }

    const owner = this.ownerTarget.value
    this._reset(this.portfolioTarget)
    if (!owner) return

    this._fetch(this.data.get('url'), { commercial_id: owner })
      .then((books) => this._fillPortfolios(Array.isArray(books) ? books : []))
  }

  // A commercial files in their own books; anyone else, in any of the client's.
  _booksForOwner() {
    const id = this.ownerTarget.value
    const owner = (this._owners || []).find((o) => String(o.id) === String(id))
    if (!owner || !owner.commercial) return this._books
    return this._books.filter((b) => (b.commercials || []).some((c) => String(c.id) === String(id)))
  }

  _fillOwners() {
    if (!this.hasOwnerTarget) return
    const selected = this.ownerTarget.value
    this.ownerTarget.innerHTML = ''
    this._owners.forEach((o) => this.ownerTarget.add(new Option(o.name, o.id)))
    if (this._owners.some((o) => String(o.id) === String(selected))) this.ownerTarget.value = selected
  }

  _fillPortfolios(books) {
    const selected = this._preselect || this.portfolioTarget.value
    this._preselect = null
    this._reset(this.portfolioTarget)
    books.forEach((b) => this.portfolioTarget.add(new Option(b.name, b.id)))
    if (this.hasWrapperTarget) this.wrapperTarget.hidden = books.length === 0
    if (selected && books.some((b) => String(b.id) === String(selected))) this.portfolioTarget.value = selected
  }

  _fetch(path, params) {
    const url = new URL(path, window.location.origin)
    Object.entries(params).forEach(([k, v]) => url.searchParams.set(k, v))
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => data || [])
      .catch(() => [])
  }

  _reset(select) {
    if (!select) return
    const prompt = select.options[0]
    while (select.options.length) select.remove(0)
    if (prompt) select.add(prompt)
  }
}
